import { render, staticRenderFns } from "./Forget_Password.vue?vue&type=template&id=5b2c6083&scoped=true&"
import script from "./Forget_Password.vue?vue&type=script&lang=js&"
export * from "./Forget_Password.vue?vue&type=script&lang=js&"
import style0 from "./Forget_Password.vue?vue&type=style&index=0&id=5b2c6083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c6083",
  null
  
)

export default component.exports